<template lang="pug">
portal(
  :to="`${DIALOG_PORTAL_KEY}.content`"
  v-slot="{ close }"
)
  .d-flex.flex-column.gap-16
    p.text-justify.body-2 Если вы здесь для участия в мероприятиях, рекомендуем (даже настаиваем) вам использовать специальное мобильное приложение «Афиша мероприятий»
    app-button.full-width(
      :href="appLink"
      target="_blank"
    )
      p.body-2 Открыть приложение
    app-button.full-width.close-button.rounded-12.overflow-x-hidden(
      height="auto"
      :style-type="STYLE_TYPE.text"
      @click="close"
    )
      p.text-wrap.caption {{ !$user.isAuthenticated ? 'Я организатор и хочу именно с телефона работать на платформе' : 'Закрыть' }}
</template>

<script>
import AppButton, { STYLE_TYPE } from '@/components/user-redesign/controls/AppButton.vue';

const DIALOG_PORTAL_KEY = 'welcome-dialog-portal';

export default {
  name: 'MobileDialog',
  components: {
    AppButton,
  },
  props: {},
  data() {
    return {
      DIALOG_PORTAL_KEY,
      STYLE_TYPE,
    };
  },
  computed: {
    appLink() {
      const { APPLICATION_IOS, APPLICATION_ANDROID } = this.$conf;
      if (/iPhone|iPad|iPod|Mac|iPad Simulator|iPhone Simulator|iPod Simulator/i.test(navigator.userAgent)) {
        return APPLICATION_IOS;
      }
      return APPLICATION_ANDROID;
    },
  },
  watch: {},
  mounted() {
    if (this.$conf.isMobile && (!this.$user.isAuthenticated || this.$user.isMember)) {
      /** Не подгружает контейнер диалогов сразу (не открывается диалог).
       * Не понимаю, в чём проблема, пытался через nextTick, та же история.
       * Если у кого-то хватит мозгов, как без костылей запустить
       * диалог, то извольте исправить эту несостоятельность ниже
       */
      setTimeout(() => this.openDialog(), 1000);
      // this.openDialog();
    }
  },
  methods: {
    openDialog() {
      this.$dialogs.portal({
        attrs: {
          'max-width': 800,
          title: 'Мобильное приложение',
          inputValue: DIALOG_PORTAL_KEY,
          persistent: true,
          scrollable: false,
          hideActions: true,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.close-button {
  &::v-deep .v-btn__content {
    overflow-x: hidden;
    width: 100%;
  }
}
</style>
